import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../utils/userProvider";
import axios from "axios";
import moment from "moment";
const FileDownload = require("js-file-download");

export default function useDownloadReport() {
  const backend_url = process.env.REACT_APP_BACKEND_URL;
  const { authState, setAuthState } = useContext(AuthContext);
  let target = `${backend_url}/agents/download`;

  //id, status, remarks
  const [data, setData] = useState();

  const [res, setRes] = useState({
    data: null,
    complete: false,
    loading: false,
    error: false,
  });

  useEffect(() => {
    if (!data) return;
    setRes({
      data: null,
      loading: true,
      error: false,
      complete: false,
    });
    axios({
      url: target + `/${data.id}`,
      method: "POST",
      responseType: "blob",
      data: data,
      headers: {
        Authorization: `Bearer ${authState.jwt ? authState.jwt : ""}`,
      },
    })
      .then(
        (res) => {
          console.log(res.data);
          FileDownload(
            res.data,
            data.agency_name + moment().format("DDMMYYYY") + ".xlsx"
          );
          setRes({
            data: "success",
            loading: false,
            error: false,
            complete: true,
          });
        }
        /* setRes({
          data: res.data,
          loading: false,
          error: false,
          complete: true,
        }) */
      )
      .catch((e) => {
        const fileReader = new FileReader();
        return new Promise((resolve, reject) => {
          try {
            fileReader.onerror = () => {
              fileReader.abort();
              reject(new Error("Problem parsing Error Message"));
            };

            fileReader.onload = () => {
              let message = JSON.parse(fileReader.result);
              setRes({
                data: null,
                loading: false,
                error: true,
                errorMessage: message.message,
                complete: true,
              });
              resolve();
            };

            fileReader.readAsText(e.response.data);
          } catch (err) {
            console.log(e.message);
            setRes({
              data: null,
              loading: false,
              error: true,
              errorMessage: e.message,
              complete: true,
            });
          }
        });
        /* console.log(e.response.data.message);
        setRes({
          data: null,
          loading: false,
          error: true,
          errorMessage: e.response,
          complete: true,
        }); */
      });
  }, [data]);

  return [res, setData];
}
